<template>
<div class="small-width p-t-40">
  <div class="customer row">
    <div class="col-xs-4 sticky-100">
      <div class="flex-center m-b-40 h-40">
        <div class="flex-center">
          <Btn
            @click.native="routeIt"
            class="light bordered empty d-inline-block m-r-15 fix-40"
            :icon="{
              name: 'arrowLeftBig',
              size: '20',
            }" />
          <p class="user-name">{{ $t('customer') }} # {{ $route.params.id }}</p>
        </div>
      </div>
      <div class="user-card">
        <div class="card">
          <div class="image-holder showIcon">
            <Icon
              name="single"
              :size="64" />
          </div>
          <p class="title-name m-b-20">
            {{ get_customer.type == 1 ? get_customer.company_name : get_customer.name }}
          </p>
          <p class="info-list-title" v-if="get_customer.type == 1">{{ get_customer.name }}</p>
          <p class="info-list-title" v-if="get_customer.external_customer_no">External customer no: {{ get_customer.external_customer_no }}</p>
          <ul class="contact-info">
            <li>
              <Icon
                :circle="true"
                name="pin"
                size="20"
                />
              <p class="info-list-title">{{ $t('address_1') }}</p>
              <p class="info-list-text">{{ get_customer.address_1 }}</p>
              <p class="info-list-text" v-if="get_customer.address_2">{{ get_customer.address_2 }}</p>
              <p class="info-list-text">{{ `${get_customer.post_code} ${get_customer.city}` }}</p>
              <p class="info-list-text">{{ get_customer.country }}</p>
              <p class="info-list-text" v-if="get_customer.state">{{ get_customer.state }}</p>
              <p class="info-list-text" v-if="get_customer.vat">{{ get_customer.vat }}</p>
            </li>
          </ul>
          <div class="clear-float">
            <Btn
              @btnClick="openEditPopup"
              class="brand d-inline-block"
              :icon="{
                name: 'pen',
                size: '18',
              }"
              :btnText="$t('Edit profile')" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-xs-8">
      <h2 class="page-title heighted">{{ $t('contacts') }}</h2>
      <div class="table">
        <div class="table-body">
            <div v-for="(item, index) in addressesForRender" :key="`tr-${index}`">
              <TableRow
                style="cursor: pointer;"
                @click.native="openAddressFormPopup(item)"
                :type="type"
                :listItem="{...item, country_id: getCountry(item.country_id, 'name')}"
                :data="referenceData" />
            </div>
        </div>
        <Btn
          @btnClick="openAddressFormPopup"
          class="brand d-inline-block"
          :icon="{
            name: 'pen',
            size: '18',
          }"
          :btnText="$t('add_contact')" />
      </div>
    </div>
  </div>
  <Popup
    v-if="edit"
    :isPopupSubmitDisabled="isPopupSubmitDisabled"
    :showDeleteButton="deleteCustomer"
    :showConfirmButton="!deleteCustomer"
    @deleteAction="deleteCustomerAction"
    @cancel="closeEditPopup"
    @confirm="submitEditForm">
    <template v-slot:header>
      <h2>{{ $t('edit') }} {{ get_customer.name}}</h2>
    </template>
    <div>
      <div class="row">
        <div class="col-xs-12 m-b-20">
          <InputSelect
            :label="$t('type')"
            v-model="formInfo.type"
            :options="typeOptions" />
        </div>
        <InputText
          v-if="formInfo.type == 1"
          class="col-xs-12 m-b-20"
          :label="$t('vat')"
          :rules="{required: false}"
          v-model="formInfo.vat"/>
        <InputText
          v-if="formInfo.type == 1"
          class="col-xs-12 m-b-20"
          :label="$t('company')"
          :rules="{required: true}"
          v-model="formInfo.company_name"/>
        <InputText
          class="col-xs-12 m-b-20"
          :label="$t('name')"
          v-model="formInfo.name"
          :rules="{required: formInfo.type == 2}" />
      </div>
      <AddressPicker
        class="m-b-input m-b-20"
        :label="$t('address_1')"
        placeholder="Search address"
        @addressSelected="changeAddress($event)"
        v-model="formAddress" />
      <div class="row">
        <InputText
          class="col-xs-12 m-b-20"
          :label="$t('external_customer_no')"
          v-model="formInfo.external_customer_no"
          :rules="{required: false}"/>
      </div>
      <div class="clear-float separator medium"></div>
      <div class="col-xs-12 p-b-20">
        <div class="flex-center toggle-title">
          <div>
            <p>{{ $t('delete') }}</p>
            <span>{{ $t('Customer will be deleted') }}</span>
          </div>
          <div>
            <Toggle color="red" id="deleteCustomer" v-model="deleteCustomer"/>
          </div>
        </div>
      </div>
    </div>
  </Popup>
  <!-- ADDRESS POPUP -->
  <Popup
    v-if="addressFormPopup"
    :isPopupSubmitDisabled="isPopupAddressSubmitDisabled"
    :showConfirmButton="!deleteAddress"
    :showDeleteButton="deleteAddress"
    @deleteAction="deleteAddressAction"
    @cancel="closeAddressFormPopup"
    @confirm="submitAddressForm">
    <template v-slot:header>
      <h2 v-if="!isAddressEdit">{{ $t('add_contact') }}</h2>
      <h2 v-else>{{ $t('edit_contact') }}</h2>
    </template>
    <div>
      <div class="row m-b-20">
        <InputText
          class="col-xs-12"
          :label="$t('name')"
          :rules="{required: true}"
          v-model="addressFormInfo.name" />
      </div>
      <div class="row m-b-20">
        <InputText
          class="col-xs-12 m-b-20"
          label="Email"
          v-model="addressFormInfo.email"
          :rules="{required: true}"/>
        <PhoneSelect
          class="col-xs-12 m-b-20"
          v-model="addressFormInfo.phone"
          :rules="{required: true}"/>
      </div>
      <div class="separator medium" v-if="isAddressEdit"></div>
      <div class="col-xs-12 p-b-20" v-if="isAddressEdit">
        <div class="flex-center toggle-title">
          <div>
            <p>{{ $t('delete') }}</p>
            <span>{{ $t('Contact will be deleted') }}</span>
          </div>
          <div>
            <Toggle color="red" id="delete" v-model="deleteAddress" />
          </div>
        </div>
      </div>
    </div>
  </Popup>
</div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import AddressPicker from '@/components/global/addressPicker/index.vue';
import PhoneSelect from '@/components/elements/inputs/phone.vue';
import TableRow from '@/components/table/tableRow.vue';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';

import formValidator from '@/mixins/formValidator';
import mixins from '@/mixins/mixins';
import stateList from '@/data/state.js';

export default {
  name: 'Customer',
  components: {
    Btn,
    Popup,
    InputText,
    AddressPicker,
    PhoneSelect,
    TableRow,
    InputSelect,
    Toggle,
  },
  mixins: [mixins, formValidator],
  data() {
    return {
      // REFACTOR ADDRESS FORM
      addressFormPopup: false,
      isAddressEdit: false,
      deleteAddress: false,
      addressId: '',
      addressFormAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      },
      addressFormInfo: {
        name: '',
        email: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
      },
      // Customer form
      edit: false,
      deleteCustomer: false,
      formInfo: {
        name: '',
        company_name: '',
        email: '',
        type: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
        external_customer_no: ''
      },
      formAddress: {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      },
      typeOptions: [
        {
          text: `${this.$t('Private')}`,
          value: 2,
        },
        {
          text: `${this.$t('Business')}`,
          value: 1,
        }
      ],
      // Table
      type: {
        type: false,
        data: 'type', // generate_invoice_spec_file_type
        text: `${this.$t('type')}`,
        icons: {
          1: 'single',
          2: 'building',
        },
      },
      referenceData: [
        {
          name: `${this.$t('name')}`,
        },
        {
          phone: this.$t('phone'),
          email: 'Email',
        },
      ],
    };
  },
  created() {
    this.$store.dispatch('GET_CUSTOMER', this.$route.params.id).then(() => {
      this.formInfo = {
        name: this.get_customer.name,
        company_name: this.get_customer.company_name,
        email: this.get_customer.email,
        vat: this.get_customer.vat,
        type: this.get_customer.type,
        phone: {
          number: this.get_customer.phone,
          country: '',
        },
        external_customer_no: this.get_customer.external_customer_no
      };
      this.formAddress = {
        address_1: this.get_customer.address_1,
        address_2: this.get_customer.address_2,
        post_code: this.get_customer.post_code,
        city: this.get_customer.city,
        state: this.get_customer.state,
        country_id: this.get_customer.country_id,
      };
    });
  },
  computed: {
    ...mapGetters(['get_customer','get_active_subaccount']),
    isPopupSubmitDisabled() {
      if(this.formInfo.phone &&  this.formInfo.phone.number && this.formInfo.phone.number.length < 6) return true;
      let formWithValidators = [
        {
          formFeild:'country_id',
          value: this.formAddress.country_id,
          validators:{required: true}
        },
        {
          formFeild:'post_code',
          value: this.formAddress.post_code,
          validators:{required: true}
        },
        {
          formFeild:'city',
          value: this.formAddress.city,
          validators:{required: true}
        },
        {
          formFeild:'address_1',
          value: this.formAddress.address_1,
          validators:{required: true}
        },
        {
          formFeild:'name',
          value: this.formInfo.name,
          validators:{required: this.formInfo.type == 2}
        }
      ]

      if(this.formInfo.type == 1){
        formWithValidators.push({
          formFeild:'company_name',
          value: this.formInfo.company_name,
          validators:{required: true}
        })
      } else {
        formWithValidators.filter((item) => item.formFeild != 'company_name')
      }

      return this.validateInput(formWithValidators);
    },
    isPopupAddressSubmitDisabled() {
      const formWithValidators = [
        {
          formFeild:'name',
          value: this.addressFormInfo.name,
          validators:{required: true}
        },
      ]

      return this.validateInput(formWithValidators);
    },
    addressesForRender() {
      if(!this.get_customer.hasOwnProperty('addresses')) return [];
      return this.get_customer.addresses.map((address) => {
        return address;
      });
    },
  },
  methods: {
    routeIt() {
      this.$router.go(-1);
    },
    // Edit address popup
    openAddressFormPopup(item) {
      this.addressFormPopup = true;
      this.addressFormAddress = {
        address_1: this.get_customer.address_1,
        address_2: this.get_customer.address_2,
        post_code: this.get_customer.post_code,
        city: this.get_customer.city,
        state: this.get_customer.state,
        country_id: this.get_customer.country_id,
      };
      if(typeof item == 'undefined'){
        // ADD FORM POPUP
        this.isAddressEdit = false;
        this.addressFormInfo = {
          name: '',
          email: '',
          vat: '',
          phone: {
            number: '',
            country: this.getCountry(this.get_customer.country_id, 'alpha2'),
          },
        }
      } else {
        // EDIT FORM POPUP
        this.isAddressEdit = true;
        this.addressId = item.id;
        this.addressFormInfo = {
          name: item.name,
          email: item.email,
          vat: item.vat,
          phone: {
            number: item.phone,
            country: this.getCountry(item.country_id, 'alpha2'),
          },
        };
      }

    },
    closeAddressFormPopup() {
      this.addressFormPopup = false;
      this.isAddressEdit = false;
      this.deleteAddress = false;
      this.addressId = '';
      this.addressFormAddress = {
        address_1: '',
        address_2: '',
        post_code: '',
        city: '',
        state: '',
        country_id: '',
      };
      this.addressFormInfo = {
        name: '',
        email: '',
        vat: '',
        phone: {
          number: '',
          country: '',
        },
      };
    },
    changeAddressForm(val) {
      this.addressFormAddress.address_1 = val.address_1 || '';
      this.addressFormAddress.address_2 = val.address_2 || '';
      this.addressFormAddress.country_id = val.country_id || '';
      this.addressFormAddress.post_code = val.post_code || '';
      this.addressFormAddress.city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if(state.country_name ==  this.getCountry(val.country_id, 'name')){
          flag = true;
        }
      });

      if(flag){
        this.addressFormAddress.state = val.state;
      } else {
        this.addressFormAddress.state = '';
      }
    },
    submitAddressForm() {
      if(!this.isAddressEdit) {
        // SUBMIT ADD ADRESS
        this.$store.dispatch('ADD_CUSTOMER_ADDRESS', {
          form: {...this.addressFormAddress, ...this.addressFormInfo, phone: this.addressFormInfo.phone.number, company_name: this.get_customer.company_name},
          id: this.$route.params.id,
        }).then(() => {
          this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
          this.closeAddressFormPopup();
        });
      } else {
        // SUBMIT EDIT ADRESS
        this.$store.dispatch('EDIT_CUSTOMER_ADDRESS', {
          form: {...this.addressFormAddress, ...this.addressFormInfo, phone: this.addressFormInfo.phone.number, company_name: this.get_customer.company_name},
          id: this.$route.params.id,
          addressId: this.addressId,
        }).then(() => {
          this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
          this.closeAddressFormPopup();
        });
      }
    },
    deleteAddressAction() {
      this.$store.dispatch('DELETE_CUSTOMER_ADDRESS', {
        customerId: this.$route.params.id,
        addressId: this.addressId,
      }).then(() => {
        this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
        this.closeAddressFormPopup();
      })
    },
    // Customer popup
    openEditPopup() {
      this.edit = true;
    },
    closeEditPopup() {
      this.edit = false;
    },
    changeAddress(val) {
      this.formAddress.address_1 = val.address_1 || '';
      this.formAddress.address_2 = val.address_2 || '';
      this.formAddress.country_id = val.country_id || '';
      this.formAddress.post_code = val.post_code || '';
      this.formAddress.city = val.city || '';

      let flag = false;
      stateList.forEach((state) => {
        if(state.country_name ==  this.getCountry(val.country_id, 'name')){
          flag = true;
        }
      });

      if(flag){
        this.form.state = val.state;
      } else {
        this.form.state = '';
      }
    },
    submitEditForm() {
      this.$store.dispatch('EDIT_CUSTOMER', {
        form: {
          ...this.formAddress,
          ...this.formInfo,
          phone: this.formInfo.phone.number
        },
        id: this.$route.params.id,
      }).then(() => {
        this.$store.dispatch('GET_CUSTOMER', this.$route.params.id);
        this.edit = false;
      });
    },
    deleteCustomerAction() {
      this.$store.dispatch('DELETE_CUSTOMERS', {
        type: 'byId',
        id: 0,
        ids: [this.$route.params.id],
      }).then(() => {
        this.$router.push('/contacts')
      });
    },
  },
  beforeDestroy() {
    this.$store.dispatch('CLEAR_CUSTOMER_FROM_STORE');
  },
};
</script>
